import styled from "styled-components";
import Input from "antd/es/input";

export const BigSearchInput = styled(Input)`
    position: relative;
    border-radius: 4px;
    background: #f7f7f7;
    border: none;
    padding: 2px 4px 2px 32px;

    &:hover, &:focus, &.ant-input-affix-wrapper-focused {
        border: none;
        box-shadow: none;
        background: #f7f7f7;
    }

    .ant-input-prefix {
        position: absolute;
        left: 6px;
        top: 50%;
        transform: translateY(-50%);
        color: #000;
        font-size: 16px;
    }

    input {
        background: transparent;
        font-size: 16px;
    }
`;


